module.exports = __webpack_public_path__ + "img/observer.42178b8e.png";